import { Box, Typography, Divider } from "@mui/material";
import { useFormatter } from "@/utils/useFormatter";
import { ActivationResponsible } from "../helpers/activationInfo";

interface ActivationInfoBlockProps {
  responsible: ActivationResponsible;
  providerLabel?: string;
}

export function ActivationInfoBlock({
  responsible,
  providerLabel,
}: ActivationInfoBlockProps) {
  return (
    <>
      <Divider sx={{ marginY: 2 }} />
      <Typography
        variant="body1"
        fontWeight="600"
        textAlign="center"
        gutterBottom
      >
        Informações da ativação
      </Typography>
      <Box
        sx={{
          backgroundColor: "neutral100.main",
          p: 2,
          borderRadius: 2,
          mb: 1,
        }}
      >
        <Typography
          variant="body2"
          fontWeight="600"
          color="text.secondary"
          sx={{ mb: 1.5, textTransform: "uppercase", letterSpacing: 0.5 }}
        >
          Responsável
        </Typography>
        <Typography
          variant="body1"
          fontWeight="500"
          sx={{ mb: 1, wordWrap: "break-word", overflow: "hidden" }}
        >
          <strong>Nome:</strong> {responsible.nome}
        </Typography>
        <Typography variant="body1" fontWeight="500" sx={{ mb: 1 }}>
          <strong>CPF:</strong>{" "}
          {responsible.cpf !== "-"
            ? useFormatter?.formatCPF(responsible.cpf) || responsible.cpf
            : "-"}
        </Typography>
        <Typography
          variant="body1"
          fontWeight="500"
          sx={{ mb: providerLabel ? 2 : 0, wordWrap: "break-word", overflow: "hidden" }}
        >
          <strong>Email:</strong> {responsible.email}
        </Typography>

        {providerLabel && (
          <>
            <Typography
              variant="body2"
              fontWeight="600"
              color="text.secondary"
              sx={{ mb: 1, textTransform: "uppercase", letterSpacing: 0.5 }}
            >
              Provedor
            </Typography>
            <Typography variant="body1" fontWeight="500">
              <strong>Provedor:</strong> {providerLabel}
            </Typography>
          </>
        )}
      </Box>
    </>
  );
}
